import Footer from '../Footer/Footer';
import Header from '../Header/Header';

import './PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <Header />
      <div className="privacy-policy">
        <h1 className="privacy-policy__title">
          Политика конфиденциальности персональных данных
        </h1>
        <p className="privacy-policy__meta">
          г. Пермь
          <br />
          ООО «Шахматная Школа»
          <br />
          «1» сентября 2018 г.
        </p>

        {/* 1 */}
        <div className="privacy-policy__section">
          <h2 className="privacy-policy__section-title">1. Общие положения</h2>
          <p className="privacy-policy__text">
            1.1. Настоящая Политика конфиденциальности персональных данных
            (далее – Политика) разработана в соответствии с Федеральным
            27.07.2006 № 152-ФЗ «О персональных данных», Постановлением
            Правительства РФ от 01.11.2012 № 1119, ГК РФ, Трудовым кодексом РФ и
            иными нормативными актами, регулирующими обработку и защиту
            персональных данных.
          </p>
          <p className="privacy-policy__text">
            1.2. Политика действует в отношении всей информации, которую
            Общество с ограниченной ответственностью «Шахматная Школа» (ООО
            «Шахматная Школа», ИНН 5905026580, ОГРН 1155958015421, юридический
            адрес: 614016, г. Пермь, ул. Куйбышева, д. 54; далее – Оператор)
            может получить о Пользователе во время использования сайта{' '}
            <a
              href="https://www.шахматыпермь.рф"
              className="privacy-policy__link"
            >
              https://www.шахматыпермь.рф
            </a>{' '}
            (далее – Сайт), в т. ч. личного кабинета, а также программ,
            сервисов, продуктов, услуг Оператора.
          </p>
          <p className="privacy-policy__text">
            1.3. Под Пользователем в настоящей Политике понимается физическое
            лицо, использующее Сайт и (или) иные ресурсы Оператора, а также
            предоставляющее свои персональные данные в целях, указанных в
            настоящей Политике.
          </p>
          <p className="privacy-policy__text">
            1.4. Целью настоящей Политики является обеспечение надлежащей защиты
            персональных данных Пользователей от неправомерного доступа и
            раскрытия.
          </p>
          <p className="privacy-policy__text">
            1.5. Использование Сайта Пользователем означает безоговорочное
            согласие с настоящей Политикой. В случае несогласия с условиями
            Пользователь обязан прекратить использование Сайта и сервисов.
          </p>
        </div>

        {/* 2 */}
        <div className="privacy-policy__section">
          <h2 className="privacy-policy__section-title">
            2. Термины и определения
          </h2>
          <p className="privacy-policy__text">
            Персональные данные, Обработка персональных данных, Оператор,
            Пользователь, Cookie, IP-адрес и иные термины употребляются в
            значениях, указанных в Федеральном законе № 152-ФЗ.
          </p>
        </div>

        {/* 3 */}
        <div className="privacy-policy__section">
          <h2 className="privacy-policy__section-title">
            3. Категории персональных данных, обрабатываемых Оператором
          </h2>
          <p className="privacy-policy__text">
            3.1. Оператор обрабатывает следующие категории персональных данных
            Пользователей:
          </p>
          <ul className="privacy-policy__list">
            <li className="privacy-policy__list-item">
              <strong>
                Общие сведения о родителях (законных представителях):
              </strong>
              <ul className="privacy-policy__list">
                <li className="privacy-policy__list-item">
                  фамилия, имя, отчество;
                </li>
                <li className="privacy-policy__list-item">
                  мобильный телефон;
                </li>
                <li className="privacy-policy__list-item">
                  адрес электронной почты;
                </li>
                <li className="privacy-policy__list-item">
                  данные авторизации (логин, пароль) при регистрации в личном
                  кабинете;
                </li>
                <li className="privacy-policy__list-item">
                  IP-адрес, Cookie, идентификаторы браузера, сведения об
                  оборудовании, устройство, язык ОС и браузера.
                </li>
              </ul>
            </li>
            <li className="privacy-policy__list-item">
              <strong>
                Сведения о несовершеннолетних обучающихся (детях):
              </strong>
              <ul className="privacy-policy__list">
                <li className="privacy-policy__list-item">
                  фамилия, имя, отчество;
                </li>
                <li className="privacy-policy__list-item">дата рождения;</li>
                <li className="privacy-policy__list-item">пол;</li>
                <li className="privacy-policy__list-item">
                  наименование образовательной организации;
                </li>
                <li className="privacy-policy__list-item">
                  класс (при наличии).
                </li>
              </ul>
            </li>
            <li className="privacy-policy__list-item">
              <strong>Платежные данные:</strong>
              <ul className="privacy-policy__list">
                <li className="privacy-policy__list-item">
                  сведения о платежах, включающие реквизиты транзакции, дату,
                  сумму, маску карты посредством ЮKassa (ООО НКО ЮМани), без
                  хранения реквизитов банковских карт на стороне Оператора.
                </li>
              </ul>
            </li>
          </ul>
          <p className="privacy-policy__text">
            3.2. Оператор не осуществляет обработку биометрических и специальных
            категорий персональных данных (расовая, национальная принадлежность,
            политические взгляды, религиозные убеждения и т. д.).
          </p>
        </div>

        {/* 4 */}
        <div className="privacy-policy__section">
          <h2 className="privacy-policy__section-title">
            4. Правовые основания обработки Персональных Данных
          </h2>
          4.1. Обработка Персональных Данных осуществляется на следующих
          основаниях:
          <ul className="privacy-policy__list">
            <li className="privacy-policy__list-item">
              ст. 24 Конституции РФ;
            </li>
            <li className="privacy-policy__list-item">
              Федеральный закон № 152-ФЗ;
            </li>
            <li className="privacy-policy__list-item">
              согласие субъектов персональных данных;
            </li>
            <li className="privacy-policy__list-item">
              пользовательское соглашение Оператора;
            </li>
            <li className="privacy-policy__list-item">
              выполнение договора/оказание услуги;
            </li>
            <li className="privacy-policy__list-item">
              исполнение обязанностей, возложенных на Оператора
              законодательством РФ.
            </li>
          </ul>
        </div>

        {/* 5 */}
        <div className="privacy-policy__section">
          <h2 className="privacy-policy__section-title">
            5. Цели обработки Персональных Данных
          </h2>
          5.1. Персональные данные обрабатываются в целях:
          <ul className="privacy-policy__list">
            <li className="privacy-policy__list-item">
              идентификации Пользователя на Сайте и в личном кабинете;
            </li>
            <li className="privacy-policy__list-item">
              регистрации учетной записи, предоставления доступа к функционалу;
            </li>
            <li className="privacy-policy__list-item">
              заключения и исполнения договора оказания услуг;
            </li>
            <li className="privacy-policy__list-item">
              осуществления связи с Пользователем;
            </li>
            <li className="privacy-policy__list-item">
              организации обучения, учета успеваемости;
            </li>
            <li className="privacy-policy__list-item">
              оказания технической и информационной поддержки;
            </li>
            <li className="privacy-policy__list-item">
              обработки платежей и возвратов;
            </li>
            <li className="privacy-policy__list-item">
              направления уведомлений, касающихся работы Сайта и услуг;
            </li>
            <li className="privacy-policy__list-item">
              отправки маркетинговых и рекламных материалов (при отдельном
              согласии);
            </li>
            <li className="privacy-policy__list-item">
              статистических и аналитических целей по улучшению работы Сайта;
            </li>
            <li className="privacy-policy__list-item">
              исполнения требований законодательства РФ.
            </li>
          </ul>
          5.2 Оператор осуществляет сбор и обработку изображений (фотографий,
          видеоматериалов) клиентов и тренеров исключительно при наличии
          письменного согласия субъектов персональных данных на их размещение на
          Сайте, в социальных сетях и рекламных материалах. Такие материалы
          используются исключительно в целях информирования о деятельности Школы
          и популяризации шахмат. Все изображения сотрудников ООО Шахматная
          школа и учащихся опубликованы с их письменного согласия. Копирование и
          использование фотографий третьими лицами запрещено.
        </div>

        {/* 6 */}
        <div className="privacy-policy__section">
          <h2 className="privacy-policy__section-title">
            6. Принципы и условия обработки Персональных Данных
          </h2>
          <p className="privacy-policy__text">
            6.1. Обработка осуществляется на законной и справедливой основе, с
            ограничением её целями, не допускается обработка несовместимая с
            целями сбора.
          </p>
          <p className="privacy-policy__text">
            6.2. Обрабатываются только персональные данные, которые отвечают
            целям такой обработки.
          </p>
          <p className="privacy-policy__text">
            6.3. Обработка Персональных Данных осуществляется с соблюдением
            принципов и требований законодательства РФ.
          </p>
        </div>

        {/* 7 */}
        <div className="privacy-policy__section">
          <h2 className="privacy-policy__section-title">
            7. Порядок и способы обработки Персональных Данных
          </h2>
          <p className="privacy-policy__text">
            7.1. Оператор осуществляет обработку Персональных Данных с
            использованием средств автоматизации и без (бумажные носители).
          </p>
          <p className="privacy-policy__text">
            7.2. Персональные данные Пользователя обрабатываются и хранятся на
            серверах, расположенных на территории Российской Федерации. Для
            хранения и обработки персональных данных используется инфраструктура
            компаний ООО «Регистратор доменных имен РЕГ.РУ» (ИНН 7733568767,
            адрес 125252, г. Москва, проезд Берёзовой рощи, дом 12, этаж 2,
            комната 4) и ООО «РЕГ.РУ ДОМЕНЫ ХОСТИНГ» (ИНН 6312068502, адрес
            443011, г. Самара, ул. Академика Павлова, дом 35/12, офис 12),
            являющихся зарегистрированными российскими операторами услуг.
          </p>
          <p className="privacy-policy__text">
            7.3. Сайт передает данные строго по протоколу HTTPS, сайт имеет
            валидный SSL-сертификат.
          </p>
          <p className="privacy-policy__text">
            7.4. Срок обработки – до отзыва Пользователем согласия или
            направления требования об удалении персональных данных, либо в
            течение трёх лет после завершения договорных отношений, либо до
            прекращения деятельности ООО «Шахматная школа», если иное не
            требуется по закону
          </p>
          <p className="privacy-policy__text">
            7.5. Уничтожение либо обезличивание Персональных Данных
            осуществляется Оператором при достижении целей обработки либо при
            наступлении оснований, предусмотренных законом.
          </p>
        </div>

        {/* 8 */}
        <div className="privacy-policy__section">
          <h2 className="privacy-policy__section-title">
            8. Передача Персональных Данных третьим лицам
          </h2>
          <p className="privacy-policy__text">
            8.1. Оператор вправе передавать Персональные Данные третьим лицам в
            следующих случаях:
          </p>
          <ul className="privacy-policy__list">
            <li className="privacy-policy__list-item">
              платежному агрегатору ЮKassa (ООО НКО «ЮМани») – для обработки
              оплаты;
            </li>
            <li className="privacy-policy__list-item">
              курьерским и почтовым службам (при отправке материалов) только в
              объёме, необходимом для доставки;
            </li>
            <li className="privacy-policy__list-item">
              государственным органам – в случаях и порядке, предусмотренных
              законодательством РФ;
            </li>
            <li className="privacy-policy__list-item">
              организациям, оказывающим услуги сопровождения Сайта, размещения и
              хранения данных.
            </li>
          </ul>
          <p className="privacy-policy__text">
            8.2. Передача производится на основании договоров с условием
            обеспечения конфиденциальности.
          </p>
          <p className="privacy-policy__text">
            8.3. Трансграничная передача персональных данных не осуществляется.
          </p>
        </div>

        {/* 9 */}
        <div className="privacy-policy__section">
          <h2 className="privacy-policy__section-title">
            9. Меры по защите Персональных Данных
          </h2>
          9.1. Оператор принимает необходимые правовые, организационные и
          технические меры по защите Персональных Данных, включая:
          <ul className="privacy-policy__list">
            <li className="privacy-policy__list-item">
              назначение ответственного за организацию обработки Персональных
              Данных;
            </li>
            <li className="privacy-policy__list-item">
              локальные нормативные акты;
            </li>
            <li className="privacy-policy__list-item">идентификация угроз;</li>
            <li className="privacy-policy__list-item">
              применение средств антивирусной защиты;
            </li>
            <li className="privacy-policy__list-item">ограничение доступа;</li>
            <li className="privacy-policy__list-item">
              резервное копирование;
            </li>
            <li className="privacy-policy__list-item">
              ведение учета машинных носителей Персональных Данных;
            </li>
            <li className="privacy-policy__list-item">обучение сотрудников.</li>
          </ul>
          <p className="privacy-policy__text">
            9.2. Оператор не может гарантировать абсолютной защиты данных в сети
            Интернет. Для дополнительной безопасности Пользователям
            рекомендуется:
          </p>
          <ul className="privacy-policy__list">
            <li className="privacy-policy__list-item">
              использовать сложные пароли;
            </li>
            <li className="privacy-policy__list-item">регулярно их менять;</li>
            <li className="privacy-policy__list-item">
              обновлять ПО и использовать антивирус.
            </li>
          </ul>
          <p className="privacy-policy__text">
            9.3. В случае выявления технических уязвимостей Пользователь обязан
            сообщить об этом по адресу: chessperm@yandex.ru.
          </p>
        </div>

        {/* 10 */}
        <div className="privacy-policy__section">
          <h2 className="privacy-policy__section-title">
            10. Права субъекта персональных данных
          </h2>
          10.1. Пользователь имеет право:
          <ul className="privacy-policy__list">
            <li className="privacy-policy__list-item">
              на получение информации об обработке своих Персональных Данных;
            </li>
            <li className="privacy-policy__list-item">
              требовать уточнения, блокирования или уничтожения Персональных
              Данных;
            </li>
            <li className="privacy-policy__list-item">
              отзывать ранее данное согласие, направив письменный запрос на
              электронную почту chessperm@yandex.ru;
            </li>
            <li className="privacy-policy__list-item">
              обжаловать действия Оператора в уполномоченный орган
              (Роскомнадзор) или в суд.
            </li>
          </ul>
        </div>

        {/* <!-- 11 --> */}
        <div className="privacy-policy__section">
          <h2 className="privacy-policy__section-title">
            11. Использование файлов Cookie, Метрик и аналитических инструментов
          </h2>

          <p className="privacy-policy__text">
            11.1. Оператор использует файлы Cookie, пиксели, серверные логи, а
            также сервис <strong>Яндекс.Метрика</strong> (Яндекс, ООО) для сбора
            обезличенных статистических данных о посещениях и действиях
            Пользователей на Сайте.
          </p>

          <p className="privacy-policy__text">
            11.2. Яндекс.Метрика и сопутствующие инструменты могут собирать
            обезличенные технические данные, включая: IP-адрес (в обезличенном
            виде), тип и версию браузера, разрешение экрана, данные о действиях
            на Сайте (просмотры страниц, события), URL-адрес страницы-перехода,
            дату и время запроса, сведения об устройстве и языке ОС/браузера.
          </p>

          <p className="privacy-policy__text">
            11.3. Цели обработки данных через файлы Cookie и Яндекс.Метрику:
            идентификация и авторизация Пользователя на Сайте, сохранение
            пользовательских настроек, ведение статистики посещаемости,
            аналитика поведения для улучшения качества Сайта и оказания услуг.
          </p>

          <p className="privacy-policy__text">
            11.4. Пользователь вправе отключить передачу данных в Яндекс.Метрику
            и/или отключить файлы Cookie в настройках браузера. Для отключения
            сбора данных Яндекс.Метрикой можно воспользоваться официальным
            описанием и инструментами Яндекса:{' '}
            <a
              href="https://yandex.ru/support/metrica/general/opt-out.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              инструкция по отказу от Метрики
            </a>
            .
          </p>

          <p className="privacy-policy__text">
            11.5. Отключение файлов Cookie и/или аналитики может привести к
            ограничению функционала или некорректной работе отдельных разделов
            Сайта.
          </p>
        </div>

        {/* 12 */}
        <div className="privacy-policy__section">
          <h2 className="privacy-policy__section-title">
            12. Ответственность сторон
          </h2>
          <p className="privacy-policy__text">
            12.1. Оператор несёт ответственность за нарушение обязательств по
            защите Персональных Данных в соответствии с законодательством РФ.
          </p>
          <p className="privacy-policy__text">
            12.2. В случае утраты либо разглашения Персональных Данных Оператор
            не несет ответственности, если данные:
          </p>
          <ul className="privacy-policy__list">
            <li className="privacy-policy__list-item">
              стали публичными до момента утраты;
            </li>
            <li className="privacy-policy__list-item">
              были получены от третьей стороны;
            </li>
            <li className="privacy-policy__list-item">
              разглашены с согласия Пользователя.
            </li>
          </ul>
        </div>

        {/* 13 */}
        <div className="privacy-policy__section">
          <h2 className="privacy-policy__section-title">
            13. Разрешение споров
          </h2>
          <p className="privacy-policy__text">
            13.1. Досудебный порядок является обязательным: претензии
            направляются по адресу Оператора.
          </p>
          <p className="privacy-policy__text">
            13.2. Срок ответа – 30 календарных дней.
          </p>
          <p className="privacy-policy__text">
            13.3. При недостижении согласия, спор передается в суд по месту
            нахождения Оператора.
          </p>
        </div>

        {/* 14 */}
        <div className="privacy-policy__section">
          <h2 className="privacy-policy__section-title">
            14. Заключительные положения
          </h2>
          <p className="privacy-policy__text">
            14.1. Политика размещена в свободном доступе в сети Интернет по
            адресу:{' '}
            <a
              href="https://www.шахматыпермь.рф/privacy_policy"
              className="privacy-policy__link"
              target="_blank"
              rel="noreferrer"
            >
              https://www.шахматыпермь.рф/privacy_policy
            </a>{' '}
            {/* и по адресу{' '}
            <a
              href="https://storage.yandexcloud.net/chessschoolfrontendfiles/privacy_policy.pdf"
              className="privacy-policy__link"
              target="_blank"
              rel="noreferrer"
            >
              https://storage.yandexcloud.net/chessschoolfrontendfiles/privacy_policy.pdf
            </a> */}
          </p>
          <p className="privacy-policy__text">
            14.2. Оператор вправе изменять настоящую Политику без согласия
            Пользователя. Новая редакция вступает в силу с момента публикации.
          </p>
          <p className="privacy-policy__text">
            14.3. Все предложения или вопросы направляются по адресу электронной
            почты:{' '}
            <a
              href="mailto:chessperm@yandex.ru"
              className="privacy-policy__link"
            >
              chessperm@yandex.ru
            </a>
          </p>
          <p className="privacy-policy__text">
            ООО «Шахматная Школа»
            <br />
            ИНН 5905026580, ОГРН 1155958015421
            <br />
            614016, Пермский край, г.Пермь, ул.Куйбышева 54
            <br />
            Телефон: 239-30-06, +7 (902) 632-42-93
            <br />
            E-mail: chessperm@yandex.ru
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
